import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleLeft } from "react-icons/fa";
import { getStoryDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewstory = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const storyView = useSelector((state) => state.storyView);
  const { story } = storyView;

  useEffect(() => {
    dispatch(getStoryDetails(token,id));
  }, [dispatch]);

  useEffect(() => {
    if (storyView) {
      if (storyView?.loading !== undefined) {
        setLoading(storyView?.loading);
      }
    }
  }, [storyView]);

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow"><FaAngleLeft onClick={() => navigate(-1)}/></span>
          <h1 className="view-page-tittle">View Story</h1>
        </div>
        
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              

              <img
                src={story?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>

            
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  disabled={true}
                  value={story?.data?.firstname}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  disabled={true}
                  value={story?.data?.lastname}
                  placeholder="Enter Last Name"
                />
              </div>
              {/* <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  value={story?.data?.email}
                  placeholder="Enter Email"
                />
              </div> */}

              <div className="formInput">
                <label>Description</label>

                <textarea
                  type="text"
                  disabled={true}
                  value={story?.data?.profile_story}
                  name="profile_story"
                  
                  className="description-textarea"
                  cols="43"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput"></div>

              {/* <button type="submit" disabled={true} className="submitBtn">Save</button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewstory;
